/**
 * Backoffice runtime config.
 * Override at build time via Vite env (e.g. VITE_MAX_RESULT_PHOTOS=3).
 */

function envInt(name: keyof ImportMetaEnv, fallback: number, min = 1, max = 20): number {
  const raw = import.meta.env[name];
  if (raw == null || raw === '') return fallback;
  const n = Number.parseInt(String(raw), 10);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, n));
}

export const appConfig = {
  /** Max RESULT photos per act on the piercing capture step (default 3). */
  maxResultPhotos: envInt('VITE_MAX_RESULT_PHOTOS', 3),
  /** Max LABEL (traceability) photos per act on the piercing capture step (default 5). */
  maxLabelPhotos: envInt('VITE_MAX_LABEL_PHOTOS', 5),
} as const;
